import { LoyaltyCurrentFtdType, LoyaltyLevelWithRangeType } from '../../types'

export const getCurrentLevel = ({
  currentFtd,
  inTop10,
  levels,
}: {
  currentFtd?: LoyaltyCurrentFtdType
  inTop10?: boolean
  levels: LoyaltyLevelWithRangeType[]
}) => {
  if (inTop10) {
    return levels[levels.length - 1]
  }

  if (currentFtd === undefined) {
    return null
  }

  const currentLevel = levels.find((level) => currentFtd >= level.ftdRange.from && currentFtd <= level.ftdRange.to)

  return currentLevel || null
}
